import Navbar from "../Components/Navbar/Navbar";
import View from "./View";

const ContactSuccess = ({ project, currentStatus, tracer }) => {
  return (
    <>
      <Navbar project={project} currentStatus={currentStatus} tracer={tracer} />
      <View />
    </>
  );
};

export default ContactSuccess;
